// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__VHnKQ","summary":"CartItem_summary__Cw2Xu","price":"CartItem_price__0Dphy","amount":"CartItem_amount__PxVGe","actions":"CartItem_actions__cZh7R"};